var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLalafanLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 16,
    viewBox: "0 0 164 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.913 15.3043V0.695648H145.083L157.665 8.7513V0.695648H163.916V15.3043H157.746L145.163 7.24869V15.3043H138.913Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.887 15.3043L123.698 0.695648H131.098L139.89 15.3043H133.175L131.965 13.0296H122.871L121.601 15.3043H114.887ZM125.553 8.18782L124.868 9.44H130.05L129.384 8.18782L127.711 4.64H127.308L125.553 8.18782Z",
    fill: "#111111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4653 15.3043V0.695648H119.469V5.53739H100.716V7.24869H117.291V11.673H100.716V15.3043H94.4653Z",
    fill: "#111111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4392 15.3043L79.2509 0.695648H86.651L95.4425 15.3043H88.7279L87.5181 13.0296H78.4242L77.1538 15.3043H70.4392ZM81.106 8.18782L80.4204 9.44H85.6025L84.9371 8.18782L83.2635 4.64H82.8602L81.106 8.18782Z",
    fill: "#111111"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2612 15.3043V0.695648H53.5121V10.4626H72.2645V15.3043H47.2612Z",
    fill: "#111111"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2351 15.3043L32.0468 0.695648H39.4469L48.2384 15.3043H41.5238L40.314 13.0296H31.2201L29.9497 15.3043H23.2351ZM33.9019 8.18782L33.2163 9.44H38.3984L37.733 8.18782L36.0594 4.64H35.6561L33.9019 8.18782Z",
    fill: "#111111"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0571594 15.3043V0.695648H6.30798V10.4626H25.0604V15.3043H0.0571594Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLalafanLogo);
export default __webpack_public_path__ + "static/media/lalafan_logo.d462324b77345088ce30fe24d6b2a024.svg";
export { ForwardRef as ReactComponent };